// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2rcre","card":"Cards_card__1N7pj","infected":"Cards_infected__wcxcq","recovered":"Cards_recovered__3R3u8","deaths":"Cards_deaths__2xaEy"};